import { useState } from "react";
import PropTypes from "prop-types";
import { Collapse } from "react-bootstrap";
import { ChevronDown } from "lucide-react";
import { useDispatch } from "react-redux";

import { Loader } from "components/Loader";
import { Accordion } from "components/Accordion";
import { Heading } from "style/components/Heading.styles";
import { togglePurchasePlanModal } from "Layout/slice";
import { FAQContainer, HelpCenterSubCardContainer } from "../FAQ.styles";
import { useFaqs } from "features/HelpCenter/hook";

const FAQ = () => {
  const dispatch = useDispatch();
  const { isLoading, faqs, groupedFaqs } = useFaqs();
  const [openSections, setOpenSections] = useState(() => new Set());

  const toggleSection = (section) => {
    setOpenSections((prev) => {
      const next = new Set(prev);
      if (next.has(section)) next.delete(section);
      else next.add(section);
      return next;
    });
  };

  // FAQ answers are backend HTML; open the pricing tier modal from the "here" link.
  const handleFaqBodyClick = (event) => {
    if (event.target.closest('[data-faq-action="open-pricing"]')) {
      event.preventDefault();
      dispatch(togglePurchasePlanModal(true));
    }
  };

  return (
    <HelpCenterSubCardContainer>
      <FAQContainer>
        <div className="wrapper">
          <div className="header">
            <Heading>{`FAQ's`}</Heading>
            <p>Everything you need to know about Surmount.</p>
          </div>

          {isLoading ? (
            <Loader />
          ) : (
            <div className="faq-sections" onClick={handleFaqBodyClick}>
              {groupedFaqs.map((group) => {
                const isOpen = openSections.has(group.section);
                return (
                  <div
                    key={group.section}
                    className={`faq-section${isOpen ? " open" : ""}`}
                  >
                    <button
                      type="button"
                      className="faq-section-header"
                      onClick={() => toggleSection(group.section)}
                      aria-expanded={isOpen}
                    >
                      <span className="faq-section-title">{group.section}</span>
                      <ChevronDown size={16} className="faq-section-chevron" />
                    </button>
                    <Collapse in={isOpen}>
                      <div>
                        <Accordion items={group.items} />
                      </div>
                    </Collapse>
                  </div>
                );
              })}
            </div>
          )}

          {!isLoading && faqs.length === 0 && <div>{`No FAQ's Found!`}</div>}
        </div>
      </FAQContainer>
    </HelpCenterSubCardContainer>
  );
};

FAQ.propTypes = {
  handleMenuClose: PropTypes.func,
};

export { FAQ };
